import React from 'react'
import { Card, Spinner } from 'react-bootstrap'
import { FaChartBar } from 'react-icons/fa'
import {
  FullWidthSection,
  SectionTitle,
  DetailCard,
  DetailHeader,
  HeaderControls,
  DatasetSelect,
  ChartContainer,
} from '../styles'
import ClassDistributionCard from '../../../ClassDistributionCard'

interface ClassDistributionSectionProps {
  loading: boolean
  selectedDataset: string
  onDatasetChange: (value: string) => void
  dataSources: string[]
}

const ClassDistributionSection: React.FC<ClassDistributionSectionProps> = ({
  loading,
  selectedDataset,
  onDatasetChange,
  dataSources,
}) => {
  return (
    <FullWidthSection>
      <SectionTitle>
        <FaChartBar /> Class Distribution
      </SectionTitle>
      <DetailCard style={{ height: '400px' }}>
        <DetailHeader>
          <h3>Distribution of Classes</h3>
          <HeaderControls>
            <DatasetSelect
              value={selectedDataset}
              onChange={(e) => onDatasetChange(e.target.value)}
              size="sm"
            >
              <option value="all">All Datasets</option>
              {dataSources.map((source: string) => (
                <option key={source} value={source}>
                  {source}
                </option>
              ))}
            </DatasetSelect>
          </HeaderControls>
        </DetailHeader>
        <Card.Body style={{ padding: 0, height: 'calc(100% - 50px)' }}>
          <ChartContainer className="class-distribution" style={{ margin: 0, height: '100%' }}>
            {loading ? (
              <div className="loading-overlay">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <ClassDistributionCard
                title=""
                showButtons={false}
                height="100%"
                unstyled
                useSources={selectedDataset === 'all' ? undefined : [selectedDataset]}
              />
            )}
          </ChartContainer>
        </Card.Body>
      </DetailCard>
    </FullWidthSection>
  )
}

export default ClassDistributionSection
